import iamReducer from './store/iam/reducer';
import analysisReducer from './store/analysis/reducer';
import trackedWebsitesReducer from './store/tracked_websites/reducer';
import notificationsReducer from './store/notifications/reducer';
import trackedKeywordsReducer from './store/tracked_keywords/reducer';
import regionalDatabaseReducer from './store/regional_databases/reducer';
import topKeywordsReducer from './store/top_keywords/reducer';
import keywordResearchReducer from './store/keyword_research/reducer';
import backlinksReducer from './store/backlinks/reducer';
import loadingTimeReducer from './store/loading_time/reducer';
import monitorLocationsReducer from './store/monitor_locations/reducer';
import brokenLinksReducer from './store/broken_links/reducer';
import sitemapReducer from './store/sitemap/reducer';
import outageReducer from './store/outage/reducer';
import whiteLabelReducer from './store/white_label/reducer';
import salesReducer from './store/sales/reducer';
import trackersReducer from './store/trackers/reducer';
import { backlinksApi } from './backlinks/service';

import { combineReducers, configureStore } from '@reduxjs/toolkit';
// !! ??
// @ts-ignore
import { createBrowserHistory, History } from 'history';
import { connectRouter } from 'connected-react-router';

import { routerMiddleware } from 'connected-react-router';
import accessControlMiddleware from './middleware/accessControlMiddleware';

export const history: History = createBrowserHistory();

const rootReducer = (history: History) =>
	combineReducers({
		router: connectRouter(history),
		iam: iamReducer,
		analysis: analysisReducer,
		regional_databases: regionalDatabaseReducer,
		tracked_websites: trackedWebsitesReducer,
		tracked_keywords: trackedKeywordsReducer,
		keyword_research: keywordResearchReducer,
		top_keywords: topKeywordsReducer,
		notifications: notificationsReducer,
		backlinks: backlinksReducer, // Replaced by backlinksApi
		loading_time: loadingTimeReducer,
		monitor_locations: monitorLocationsReducer,
		broken_links: brokenLinksReducer,
		sitemap: sitemapReducer,
		outage: outageReducer,
		white_label: whiteLabelReducer,
		sales: salesReducer,
		trackers: trackersReducer,

		[backlinksApi.reducerPath]: backlinksApi.reducer,
	});

const _configureStore = () => {
	const store = configureStore({
		reducer: rootReducer(history),
		// !! ??
		// @ts-ignore
		middleware: (getDefaultMiddleware) => {
			return getDefaultMiddleware()
				.concat(routerMiddleware(history))
				.concat(accessControlMiddleware)
				.concat(backlinksApi.middleware);
		},
	});
	return store;
};

export default _configureStore;
